import React from "react";

export default function MappedAssessmentIcon({
  size = 18,
  color = "black",
  margin = "0 0 0 0",
}) {
  const iconStyle = { fill: "none", stroke: color, strokeWidth: "1" };

  const iconFillStyle = { fill: color, stroke: color, strokeWidth: "1" };
  return (
    <span style={{ display: "inline-block", margin: margin }}>
      <svg
        width={size}
        height={size}
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24.7 27"
      >
        <rect x="3.5" y="7.7" style={iconStyle} width="6.5" height="6.5" />
        <rect x="3.5" y="17.2" style={iconStyle} width="6.5" height="6.5" />
        <line style={iconStyle} x1="12.4" y1="8.9" x2="21.1" y2="8.9" />
        <line style={iconStyle} x1="12.4" y1="11.6" x2="19" y2="11.6" />
        <line style={iconStyle} x1="12.4" y1="19.1" x2="21.1" y2="19.1" />
        <line style={iconStyle} x1="12.4" y1="21.8" x2="19" y2="21.8" />
        <g>
          <path
            style={iconStyle}
            d="M17.6,2.7v0.8c0,0.3-0.2,0.6-0.6,0.6H7.8c-0.3,0-0.6-0.2-0.6-0.6V2.7H0.4v24h24v-24H17.6z"
          />
          <path
            style={iconStyle}
            d="M17.6,2.7V0.9c0-0.3-0.2-0.6-0.6-0.6H7.8c-0.3,0-0.6,0.2-0.6,0.6v1.8"
          />
        </g>
        <polygon style={iconFillStyle} points="3.5,13.7 3.5,7.7 9.5,7.7 " />
        <polygon style={iconFillStyle} points="3.5,23.2 3.5,17.2 9.5,17.2 " />
      </svg>
    </span>
  );
}
